import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ServicesPage() {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-gray-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
              Done-For-You<br />STR Management<br />That Actually Works
            </h1>
            <Link
              to="/get-started"
              className="inline-flex items-center px-8 py-4 bg-amber-900 text-white rounded-full text-lg font-medium hover:bg-amber-800 transition-all whitespace-nowrap cursor-pointer"
            >
              Work With Us
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            <div className="bg-white rounded-2xl p-6 shadow-lg transform hover:scale-105 transition-transform">
              <div className="relative h-40 rounded-lg overflow-hidden mb-4">
                <img
                  src="https://public.readdy.ai/ai/img_res/18431eccbd98d3831c1d1e16d9174095.jpg"
                  alt="Listing Setup"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-bold text-gray-900">Listing Setup</h3>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg transform hover:scale-105 transition-transform md:mt-8">
              <div className="relative h-40 rounded-lg overflow-hidden mb-4">
                <img
                  src="https://readdy.ai/api/search-image?query=revenue-analytics-dashboard-showing-airbnb-performance-metrics-occupancy-rates-and-pricing-optimization-charts-professional-data-visualization-with-growth-indicators-and-booking-statistics-modern-interface-design&width=400&height=300&seq=services-hero-2&orientation=landscape"
                  alt="Performance Analytics"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-bold text-gray-900">Performance & Revenue</h3>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg transform hover:scale-105 transition-transform">
              <div className="relative h-40 rounded-lg overflow-hidden mb-4">
                <img
                  src="https://readdy.ai/api/search-image?query=professional-guest-communication-and-hospitality-management-with-smartphone-showing-booking-messages-and-five-star-reviews-friendly-customer-service-representative-managing-airbnb-reservations-modern-efficient-workflow&width=400&height=300&seq=services-hero-3&orientation=landscape"
                  alt="Guest Management"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-bold text-gray-900">Co-Hosting & Management</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Service Categories */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
            {/* Listing Setup & Optimization */}
            <div className="bg-amber-900 rounded-2xl p-10 text-white">
              <h2 className="text-3xl font-bold mb-6">Listing Setup & Optimization</h2>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-amber-300 mr-3 flex-shrink-0"></i>
                  <span className="text-amber-50"><strong>Property Selection Guidance:</strong> Expert advice on choosing profitable STR properties</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-amber-300 mr-3 flex-shrink-0"></i>
                  <span className="text-amber-50"><strong>Furnishing & Interior Design:</strong> Complete property setup with guest appeal in mind</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-amber-300 mr-3 flex-shrink-0"></i>
                  <span className="text-amber-50"><strong>Professional Staging:</strong> Photo-ready presentation that converts browsers to bookers</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-amber-300 mr-3 flex-shrink-0"></i>
                  <span className="text-amber-50"><strong>Listing Creation:</strong> Compelling descriptions and SEO-optimized titles</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-amber-300 mr-3 flex-shrink-0"></i>
                  <span className="text-amber-50"><strong>Professional Photography:</strong> High-quality images that showcase your property's best features</span>
                </li>
              </ul>
              <div className="relative h-64 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=beautifully-staged-airbnb-property-interior-with-professional-furniture-arrangement-elegant-decor-and-perfect-lighting-for-listing-photos-modern-hospitality-design-with-attention-to-guest-experience-and-visual-appeal&width=600&height=400&seq=services-listing-setup&orientation=landscape"
                  alt="Listing Setup"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Performance & Revenue */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-10">
              <div className="inline-flex items-center bg-emerald-100 text-emerald-900 px-3 py-1.5 rounded-full text-xs font-bold mb-6">
                <i className="ri-line-chart-line mr-1"></i>
                REVENUE OPTIMIZATION
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Performance & Revenue</h2>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-emerald-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Performance Audits:</strong> Comprehensive analysis of your listing's strengths and opportunities</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-emerald-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Occupancy Analysis:</strong> Data-driven insights to maximize booking rates</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-emerald-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Dynamic Pricing Strategy:</strong> Automated pricing that adapts to market demand</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-emerald-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Platform Optimization:</strong> Multi-platform presence on Airbnb, VRBO, and Booking.com</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-emerald-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Revenue Reporting:</strong> Monthly performance reports with actionable insights</span>
                </li>
              </ul>
              <div className="relative h-64 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=detailed-revenue-analytics-dashboard-with-colorful-charts-showing-airbnb-booking-trends-occupancy-rates-and-income-growth-professional-business-intelligence-interface-with-performance-metrics-and-financial-data-visualization&width=600&height=400&seq=services-performance&orientation=landscape"
                  alt="Performance Analytics"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Co-Hosting & Management */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-10">
              <div className="inline-flex items-center bg-blue-100 text-blue-900 px-3 py-1.5 rounded-full text-xs font-bold mb-6">
                <i className="ri-customer-service-2-line mr-1"></i>
                HANDS-OFF HOSTING
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Co-Hosting & Management</h2>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-blue-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Guest Communication:</strong> 24/7 professional responses to inquiries and bookings</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-blue-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Booking Management:</strong> Calendar optimization and reservation coordination</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-blue-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Review Management:</strong> Proactive review generation and response strategies</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-blue-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Operational Oversight:</strong> Check-in/check-out coordination and property maintenance</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-blue-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Issue Resolution:</strong> Quick response to guest concerns and emergencies</span>
                </li>
              </ul>
              <div className="relative h-64 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=professional-hospitality-manager-using-tablet-to-coordinate-airbnb-guest-check-in-and-booking-management-modern-property-entrance-with-welcoming-atmosphere-efficient-co-hosting-service-with-friendly-customer-care&width=600&height=400&seq=services-cohosting&orientation=landscape"
                  alt="Co-Hosting"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Virtual Assistance */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-10">
              <div className="inline-flex items-center bg-purple-100 text-purple-900 px-3 py-1.5 rounded-full text-xs font-bold mb-6">
                <i className="ri-team-line mr-1"></i>
                SUPPORT SERVICES
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Virtual Assistance & Support</h2>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Dedicated Virtual Assistants:</strong> Trained professionals managing your daily operations</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Guest Support:</strong> Pre-arrival information and during-stay assistance</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Administrative Tasks:</strong> Booking confirmations, payment tracking, and documentation</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Vendor Coordination:</strong> Managing cleaners, maintenance, and service providers</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Quality Assurance:</strong> Regular property inspections and standards maintenance</span>
                </li>
              </ul>
              <div className="relative h-64 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=professional-virtual-assistant-team-working-remotely-on-airbnb-property-management-tasks-modern-home-office-setup-with-multiple-screens-showing-booking-platforms-efficient-remote-hospitality-support-service&width=600&height=400&seq=services-virtual-assistance&orientation=landscape"
                  alt="Virtual Assistance"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Timeline */}
      <section className="py-24 bg-amber-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">Our Process</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-900 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                1
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Discovery Call</h3>
              <p className="text-sm text-gray-600">We discuss your property, goals, and current challenges</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-amber-900 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                2
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Property Audit</h3>
              <p className="text-sm text-gray-600">Comprehensive analysis of your listing and market position</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-amber-900 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                3
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Strategy Development</h3>
              <p className="text-sm text-gray-600">Custom plan tailored to your property and market</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-amber-900 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                4
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Implementation</h3>
              <p className="text-sm text-gray-600">We execute the plan and optimize your listing</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-amber-900 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                5
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Ongoing Management</h3>
              <p className="text-sm text-gray-600">Continuous optimization and performance tracking</p>
            </div>
          </div>
        </div>
      </section>

      {/* Work With Us CTA */}
      <section className="py-24 bg-gradient-to-br from-amber-900 to-amber-950">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Maximize Your STR Revenue?
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
            Let us handle the operations while you enjoy the income. Our proven systems work in any market.
          </p>
          <Link
            to="/get-started"
            className="inline-flex items-center px-10 py-4 bg-white text-amber-900 rounded-full text-lg font-medium hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Start Your Application
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}